import { Link } from "react-router-dom";
import Social from "../components/socials.js";
const Home = () => {
  return (
    <div className="sm:overflow-auto md:overflow-hidden flex sm:flex-col sm:justify-center sm:items-center home h-full bg-cream p-2 w-full m-0">
      <div className="sm:overflow-auto md:overflow-hidden w-full sm:relative md:absolute left-0 right-0 top-0 bottom-0 z-10 flex flex-col justify-start items-start sm:justify-center sm:items-center">
        {/* Mobile: Foto di atas "Tsania" */}
        <div className="sm:hidden flex flex-col items-center w-full h-fit">
          <img
            className="w-32 h-32 rounded-full z-0 bg-orangee shadow-xl mb-2 animate__animated animate__slideInUp"
            src={process.env.PUBLIC_URL + "/img/helo.png"}
            alt="Profile"
          />
          <div className="text-orangee font-semibold text-center border-b-2 my-1 pb-2">
            <p>Welcome!</p>
            <p className="text-[80px] leading-none uppercase text-orangee font-bold tracking-wider">
              Tsania.
            </p>
          </div>
        </div>
        {/* Desktop: Foto tetap di kanan */}
        <img
          className="hidden sm:block w-fit h-fit rounded-full z-0 fixed bg-cream right-0 shadow-xl sm:right-auto animate__animated animate__slideInUp"
          src={process.env.PUBLIC_URL + "/img/helo.png"}
          alt="Profile"
        />
        <div className="p-2 sm:p-0 sm:grid sm:grid-cols-2 gap-0 sm:gap-2 md:absolute h-fit sm:h-screen w-fit overflow-y-hidden overflow-x-hidden">
          {/* Desktop: "Tsania" besar di kiri */}
          <div className="hidden sm:flex sm:justify-end sm:items-end animate__animated animate__fadeInDown">
            <p className="transform rotate-90 mx-12 text-[180px] sm:text-[250px] leading-none uppercase text-orangee font-bold tracking-widest">
              Tsa
            </p>
          </div>
          <div className="sm:overflow-auto md:overflow-hidden my-2 sm:my-0 px-3 flex flex-col justify-start items-center sm:items-end animate__animated animate__slideInRight">
            <p className="uppercase text-center sm:text-end tracking-wide sm:leading-loose text-4xl text-orangee sm:text-cream font-extrabold">
              IT Generalist Outsource
            </p>

            <p className="my-1 text-center sm:text-end w-full sm:w-full text-orangee sm:text-cream font-semibold text-md">
              at Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu <br />
              <span className="text-md font-normal">
                Pemerintah Kota Surabaya [September 2023 — Present]
              </span>
            </p>
            <div className="uppercase text-center sm:text-end tracking-widest sm:leading-loose text-2xl text-orangee sm:text-cream font-bold">
              & Project Freelancer
            </div>
            <div className="border-b-2 pb-2 border-orangee"></div>
            <p className="w-full sm:w-3/5 my-2 text-center sm:text-end text-orangee sm:text-cream font-base text-sm">
              I’m an adaptable IT Generalist with a passion for connecting
              people and technology. I specialize in project management,
              full-stack website development, and data processing—helping teams
              stay secure, efficient, and prepared for what’s next.
            </p>
            <Link
              to="/project"
              className="my-2 py-2 px-6 shadow text-cream sm:text-orangee font-semibold bg-orangee sm:bg-cream rounded-2xl text-md shadow"
            >
              View My Experience Footprints
            </Link>
          </div>
          <div className="sm:overflow-auto md:overflow-hidden sm:w-[50vw] w-full sm:mb-4 px-3 sm:flex sm:flex-col text-orangee sm:text-cream sm:text-orangee justify-start sm:justify-end items-start animate__animated animate__slideInLeft">
            <div className="flex flex-col">
              <p className="text-sm sm:text-normal text-orangee">Based in</p>
              <p className="mb-1 text-md sm:text-4xl font-extrabold">
                Surabaya, Indonesia
              </p>
            </div>
            <div className="flex flex-col">
              <p className="mb-1 text-sm sm:text-sm font-normal">
                I regularly work with tools like Laravel, Node.js,
                MySQL/PostgreSQL, Git, Figma, Cyberduck, and other technologies
                related to the projects I’ve handled. I also have experience
                managing cloud VM servers for internal operations, as well as
                data collection and automation using Python and
                BeautifulSoup(BS4).
              </p>
            </div>
            <div className="flex flex-col">
              <p className="text-lg sm:text-normal text-orangee font-bold">
                My Closest Plan is..
              </p>
              <p className="mb-1 text-sm sm:text-sm font-normal">
                Pursuing a Master's Degree in a field aligned with my previous
                degree, along with collecting technical skillset in app
                development by professional job.
              </p>
            </div>
          </div>
          <div className="hidden sm:flex justify-center sm:justify-start items-center sm:items-start animate__animated animate__fadeInUp">
            <p className="transform -rotate-90 mx-12 text-[180px] sm:text-[250px] leading-none uppercase text-orangee sm:text-cream font-bold tracking-widest animate__animated">
              Nia
            </p>
          </div>
        </div>
        <Social />
      </div>
      <div className="sm:bg-orangee sm:absolute sm:right-0 sm:top-0 sm:bottom-0 sm:h-screen sm:w-[50%] sm:z-5"></div>
    </div>
  );
};

export default Home;
